import GrainOverlay from "./components/GrainOverlay";
import SmoothScroll from "./components/SmoothScroll";
import CustomCursor from "./components/CustomCursor";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Work from "./components/Work";
import ProjectGallery from "./components/ProjectGallery";
import Articles from "./components/Articles";
import About from "./components/About";
import Footer from "./components/Footer";

function App() {
  return (
    <SmoothScroll>
      <GrainOverlay />
      <CustomCursor />
      {/* Retro Frame */}
      <div className="p-[clamp(16px,3vw,40px)] min-h-screen font-sans text-ink bg-paper">
        <div className="border border-ink/10">
          <Navbar />
          <Hero />
          <Work />
          <ProjectGallery />
          <Articles />
          <About />
          <Footer />
        </div>
      </div>
    </SmoothScroll>
  );
}

export default App;
